import { Placeholder } from '@sitecore-jss/sitecore-jss-nextjs';
import { C31IconCTABorderedProps } from './C31IconCTABordered.types';
import { IconCtaBorderedProps } from '@ahc-digital/component-library';
import { ICON_CTA_BORDERED_CARDS } from 'src/shared/static';
import { useConditionalRendering } from 'src/shared/useConditionalRendering';
import { getDroplink } from 'src/shared/param-utils';

export function CreateIconCTABorderedModel(props?: C31IconCTABorderedProps) {
  type t = IconCtaBorderedProps;
  const { params, fields, rendering } = props || {};
  const { renderRichText, renderText } = useConditionalRendering();

  return {
    headline: renderText(fields?.Headline),
    supportCopy: renderRichText(fields?.SupportCopy),
    supportCopyBottom: renderRichText(fields?.SupportCopyBottom),
    headlineTag: getDroplink<t['headlineTag']>(params?.HeadlineTag, 'p'),
    numberOfColumns: getDroplink<t['numberOfColumns']>(params?.NumberOfColumns, '2'),
    children: rendering && <Placeholder name={ICON_CTA_BORDERED_CARDS} rendering={rendering} />,
  };
}
